<div class="inspector">
    <div class="inspector-headers">
      <h3>Reference</h3>
      <h3>Target</h3>
      <h3>Changes</h3>
    </div>


    <div class="inspector-content" id="tabs">
      <span class="handle"></span>
        <div class="tabs" >
            <ul>
                <li *ngIf="reference"><a  [ngClass]="{'active-tab' : tab=='reference', 'inactive-tab': tab!='reference'}" (click)="setMobileTab('reference')">Reference</a></li>
                <li *ngIf="target"><a [ngClass]="{'active-tab' : tab=='target', 'inactive-tab': tab!='target'}" (click)="setMobileTab('target')">Target</a>
                <li *ngIf="xray"><a [ngClass]="{'active-tab' : tab=='changes', 'inactive-tab': tab!='changes'}" (click)="setMobileTab('changes')">Change</a>
            </ul>
        </div>

        <div class="crop-section" [ngClass]="{'active' : tab=='reference'}">
            <figure
                #figure1
                coreSizeMe
                [monitorHeight]="true"
                [state]="size"
                (resize)="logResize($event)"
                (scroll)="onScroll($event)"
            >
                <img
                    *ngIf="reference"
                    [src]="reference.url"
                    title='Reference'
                />
            </figure>
        </div>
        <div class="crop-section" [ngClass]="{'active' : tab=='target'}">
            <figure #figure2 (scroll)="onScroll($event)">
                <img
                    *ngIf="target"
                    [src]="target.url"
                    title='Target'
                />
            </figure>
        </div>
        <div class="crop-section" [ngClass]="{'active' : tab=='changes', 'void': !xray}">
            <figure #figure3 (scroll)="onScroll($event)">
                <img
                    *ngIf="xray"
                    [src]="xray.url"
                    title='Xray'

                />
            </figure>
        </div>

    </div>
</div>
